import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql,useApolloClient } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
//import HtlAgnSeaReduction from "./HtlAgnSeaReduction";
//import HtlAgnSeasonPriceEdit from "./HtlAgnSeasonPriceEdit";
import { ProgressSpinner } from 'primereact/progressspinner';




import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12(
    $firmMainCode: String
    $firmSubCode: String
    $currentLocale: String
    $contIdSeq: Int!

  ) {
    tbl_cont_season_def(
      order_by: { firm_main_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        cont_id: { _eq: $contIdSeq }
        
      }
    ) {
      firm_main_code
      firm_sub_code
      id_seq
      cont_id
      season_id
      start_date
      end_date
      opt_1
    }
  }
`;

const UPDATE_ID_SEQ22 = gql`
mutation UpdateIdSeq2($type: String!, $increment: Int!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: $increment }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const GET_PER_DEFS = gql`
  query GetPerDefs($firmMainCode: String, 
                   $firmSubCode: String,
                   $contIdSeq: Int) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $firmMainCode }, 
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }) {
      id_seq
      period
      start_date
      end_date
      min_stay
      release
    }
  }
`;

const GET_PER_BASE = gql`
  query GetPerBase(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_base(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq }
      },
      order_by: { room_type: asc } 
    ) {   
      per_id
      room_type
      get_room_name {
        r_type_name
      }
      base_price
      period
    }
  }
`;



const GET_HTL_SEA = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    
  ) {
    tbl_htl_season(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
       
      }
    ) {
     
        id_seq
        start_date
        end_date
        desc
        active
       
    }
  }
`;


const GET_HTL_PER = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $htlSeaIdSeq: Int
    
  ) {
    tbl_htl_period(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        sea_id_seq: { _eq: $htlSeaIdSeq }
       
      }
    ) {
     
        id_seq
        sea_id_seq
        period
        start_date
        end_date
        release
        min_stay
       
    }
  }
`;

const INSERT_HTL_PER_RECORDS_MUTATION = gql`
  mutation InsertHtlPerRecordsIntoContPer($records: [tbl_cont_per_def_insert_input!]!) {
    insert_tbl_cont_per_def(objects: $records) {
      affected_rows
    }
  }
`;

const GET_HTL_SEA2 = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $htlSeaIdSeq: Int
    
  ) {
    tbl_htl_season(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        
       
      }
    ) {
     
        id_seq
        start_date
        end_date
        desc
        active
       
    }
  }
`;
const INSERT_CONT_SEA = gql`
  mutation InsertContractSea(
    $contSeaIdSeq: Int!
    $contIdSeq: Int!
    $htlSeaIdSeq: Int!
    $firmMainCode: String
    $firmSubCode: String
    $startDate: date
    $endDate: date
   
  ) {
    insert_tbl_cont_season_def(
      objects: {
        id_seq: $contSeaIdSeq,
        cont_id: $contIdSeq,
        season_id: $htlSeaIdSeq,
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        start_date: $startDate,
        end_date: $endDate
      
      }
    ) {
      affected_rows
    }
  }
`;

const GET_TBL_CONT_PER_DEF = gql`
  query GetTblContPerDef(
        $firmMainCode: String,
        $firmSubCode: String,
        $contIdSeq: Int
        ) {
    tbl_cont_per_def(where: {
                firm_main_code: { _eq: $firmMainCode }, 
                firm_sub_code: { _eq: $firmSubCode },
                cont_id: { _eq: $contIdSeq }
             }) {
      id_seq
      cont_id
      firm_main_code
      firm_sub_code
      start_date
      end_date
      period
      min_stay
      release
      get_room_types {
        r_class_code
        r_type_code
      }
    
    }
  }
`;

const GET_TBL_CONT_PER_DEF2 = gql`
  query GetTblContPerDef {
    tbl_cont_per_def {
      id_seq
      firm_main_code
      firm_sub_code
      start_date
      end_date
      period
      get_room_types {
        r_class_code
        r_type_code
      }
    }
  }
`;

const INSERT_HTL_PER_RECORDS_MUTATION_N2 = gql`
  mutation InsertHtlPerRecordsIntoContPerBase($records: [tbl_cont_per_def_base_insert_input!]!) {
    insert_tbl_cont_per_base(objects: $records) {
      affected_rows
    }
  }
`;

const INSERT_HTL_PER_RECORDS_MUTATION_N = gql`
  mutation InsertHtlPerRecordsIntoContPerBase($records: [tbl_cont_per_base_insert_input!]!) {
    insert_tbl_cont_per_base(objects: $records) {
      affected_rows
    }
  }
`;

const INSERT_TBL_CONT_PER_BASE_MUTATION = gql`
  mutation InsertTblContPerBase($records: [TblContPerBaseInput!]) {
    insert_tbl_cont_per_base(objects: $records) {
      affected_rows
    }
  }

  input TblContPerBaseInput {
    cont_id: Int!
   
  }
`;

const UPDATE_BASE_PRICE = gql`
mutation UpdateContBasePrice(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
  $contSeaIdSeq: Int
  $basePeriod: String
  $roomType: String
  $basePrice: float8 
  
) {
  update_tbl_cont_per_base(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
      sea_id: { _eq: $contSeaIdSeq }
      period: { _eq: $basePeriod }
      room_type: { _eq: $roomType }
    },
    _set: {
     base_price: $basePrice,
     
    }
  ) {
    affected_rows
  }
}
`;

const DELETE_PER_PRICE = gql`
mutation DeleteContBasePrice(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
) {
  delete_tbl_cont_per_price(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }
  ) {
    affected_rows
  }
}
`;

const DELETE_PER_GRP = gql`
mutation DeleteContPerGrp(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
) {
  delete_tbl_cont_per_grp(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }
  ) {
    affected_rows
  }
}
`;




  const GET_PER_BASE_CALC = gql`
  query GetPerBase(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_base(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq }
      },
      order_by: { room_type: asc } 
    ) {   
      per_id
      room_type
      base_price
      period
    }
  }
`;

const GET_PER_RED_CALC = gql`
  query GetPerPer(
    $firmMainCode: String,
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_per(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq }
      },
      order_by: { id_seq: asc }
    ) {
      id_seq
      cont_id
      per_id
      period
      person
      person_type
      red_sup_type
      percent
      rooms
    }
  }
`;




const INSERT_CONT_PER_PRICE_GRP = gql`
  mutation InsertContractPerPriceGrp(
     $redIdSeq: Int!,
     $contId: Int,     
     $firmMainCode: String,
     $firmSubCode: String,
     $perId: Int,   
     $perRooms: String!
     ) {
    insert_tbl_cont_per_grp(objects: { 
       id_seq: $redIdSeq, 
       cont_id: $contId,
       per_id: $perId,     
       firm_main_code: $firmMainCode,
       firm_sub_code: $firmSubCode,     
       rooms: $perRooms
      
      }) {
      affected_rows
    }
  }
`;

const GET_PRICES = gql`
  query MyQuery2($contIdSeq: Int!, $firmMainCode: String!, $firmSubCode: String!) {
    tbl_cont_per_grp(where: {
      cont_id: { _eq: $contIdSeq },
      firm_main_code: { _eq: $firmMainCode },
      firm_sub_code: { _eq: $firmSubCode }
    }) {
      id_seq
      firm_main_code
      firm_sub_code
      per_id
      cont_id
      rooms
      grp_per {
        cont_id
        id_seq
        per_id
        percent
        period
        person
        rooms
        red_sup_type
        person_type
      }
      grp_base {
        cont_id
        per_id
        period
        room_type
        base_price
        currency
      }
    }
  }
`;


const INSERT_HTL_PER_RECORDS_MUTATION_PRICE = gql`
  mutation InsertPrice($records: [tbl_cont_per_price_insert_input!]!) {
    insert_tbl_cont_per_price(objects: $records) {
      affected_rows
    }
  }
`;

const GET_ROOM_FACTOR = gql`
  query GET_ROOM_FACTOR($firmMainCode: String!, $firmSubCode: String!) {
    tbl_htl_room_type_factor(where: 
      {firm_main_code: {_eq: $firmMainCode},
       firm_sub_code: {_eq: $firmSubCode}
      
      
      })
       
       {
      factor_type
      firm_main_code
      firm_sub_code
      per_factor
      per_type
      person
      r_type_code
      get_base_factor {
        base_price_persent
      }
    }
  }
`;

const GET_HTL_PERIODS_NEW = gql`
  query GET_HTL_PERIODS($firmMainCode: String!, $firmSubCode: String!, $htlSeaIdSeq: Int) {
    tbl_htl_period(where: 
      {firm_main_code: {_eq: $firmMainCode}, 
      firm_sub_code: {_eq: $firmSubCode},
      sea_id_seq: {_eq: $htlSeaIdSeq},

    }) {
      id_seq
      firm_main_code
      firm_sub_code
      period
      sea_id_seq
      start_date
      end_date
      per_price_percent
    }
  }
`;

const INSERT_CONT_PER_PRICE_CALC_OLD = gql`
  mutation InsertContractPerPriceCalc(
     $contId: Int!,
     $perRoomClass: String!,
     $firmMainCode: String!,
     $firmSubCode: String!,
     $perId: Int!,
     $adult: Int!,
     $child: Int!,
     $perPrice: float8!,
     $currency: String!,
     $period: String!,
     $perRooms: String!,
     $days: date!,
     $updatedIdSeq: Int
  ) {
    insert_tbl_cont_per_price(objects: { 
       cont_id: $contId,
       per_id: $perId,
       period: $period,
       
       adult: $adult,
       child: $child,
       per_price: $perPrice,
       currency: $currency,
       firm_main_code: $firmMainCode,
       firm_sub_code: $firmSubCode,
       r_class_code: $perRoomClass,
       r_type_code: $perRooms,
       price_date: $days,
       red_id: $updatedIdSeq,
    }) {
      affected_rows
    }
  }
`;

const INSERT_CONT_PER_PRICE_CALC = gql`
  mutation InsertPrice($records: [tbl_cont_per_price_insert_input!]!) {
    insert_tbl_cont_per_price(objects: $records) {
      affected_rows
    }
  }
`;









const HtlSalesPlanSeasonPrice = () => {
    const { users } = useContext(UserContext);
    const { firmcode, subfirmcode, usertype, userLang, usernames } = users;
    const { id_seq } = useParams();
    const {varCode3, setVarCode3} = useContext(ThemeContext);
    const {varCode4, setVarCode4} = useContext(ThemeContext);
    const {varCode5, setVarCode5} = useContext(ThemeContext);
    const {varCode6, setVarCode6} = useContext(ThemeContext);
    const {varCode7, setVarCode7} = useContext(ThemeContext);
    const {varCode8, setVarCode8} = useContext(ThemeContext);
    const [someCondition, setSomeCondition] = useState(false);
   
    
    const firmMainCode = firmcode;
    const firmSubCode = subfirmcode;
    const username = usernames;
    const intl = useIntl();
    const currentLocale = userLang || localStorage.getItem('lang') || 'en';
  
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabS, setActiveTabS] = useState(9);
  
    const handleTabChange = (index) => {
      setActiveTab(index);
    };
  
    const handleTabChangeS = (index) => {
      setActiveTabS(index);
    };
  
    const { loading, error, data, refetch } = useQuery(GET_POST, {
      variables: { firmSubCode, firmMainCode, contIdSeq: varCode4 },
    });
  
    const ownFirmMainCode = firmcode;
    const ownFirmSubCode = subfirmcode;
    const ownFirmSubType = usertype;
  
   // const [UpdateContract] = useMutation(UPDATE_CONT);
    const [InsertContractSea] = useMutation(INSERT_CONT_SEA);
    const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ22);
    const [updateIdSeq1] = useMutation(UPDATE_ID_SEQ2);
    const [insertPerRecords] = useMutation(INSERT_HTL_PER_RECORDS_MUTATION);
    const [insertPerBaseRecords] = useMutation(INSERT_HTL_PER_RECORDS_MUTATION_N);
    const [insertPerBaseRecords2] = useMutation(INSERT_HTL_PER_RECORDS_MUTATION_PRICE);

   
   
   
   
    const [insertContPerBase] = useMutation(INSERT_TBL_CONT_PER_BASE_MUTATION);
  const { loading: tblContPerDefLoading, error: tblContPerDefError, data: tblContPerDefData } = useQuery(GET_TBL_CONT_PER_DEF);
    



    // useMutation'ı bileşen içinde kullanın
    
 
  
  
    const firmData = data && data.tbl_cont_season_def ? data.tbl_cont_season_def[0] : null;

    const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.cont_id :"");
    const [contSeaIdSeq, setContSeaIdSeq] = useState(firmData ? firmData.id_seq :"");
    const [htlSeaIdSeq, setHtlSeaIdSeq] = useState(firmData ? firmData.season_id :"");
    const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
    const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

    
    const [UpdateContBasePrice] = useMutation(UPDATE_BASE_PRICE);
    const [DeleteContBasePrice] = useMutation(DELETE_PER_PRICE);
    const [DeleteContPerGrp] = useMutation(DELETE_PER_GRP);

    const [basePeriod, setBasePeriod] = useState();
    const [roomType, setRoomType] = useState();
    const [basePrice, setBasePrice] = useState();
    const [basePricetrg, setBasePriceTrg] = useState(1);
    const [idSeqtrg, setIdSeqTrg] = useState();

    const [baseStartPrice, setBaseStartPrice] = useState();
   

   // <HtlAgnContractEdit contCurrency={currency} setContCurrency={setCurrency} />  

    
    
  
    console.log("Firm Data:", firmData);

    const { loading: htlseaLoading, error: htlseaError, data: htlseaData } = useQuery(GET_HTL_SEA, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode},
      });

      const { loading: htlperLoading, error: htlperError, data: htlperData } = useQuery(GET_HTL_PER, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, htlSeaIdSeq: htlSeaIdSeq},
      });

      const { loading: htlperroomLoading, error: htlperroomError, data: htlperroomData } = useQuery(GET_TBL_CONT_PER_DEF, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
      });

      const { loading: htlseaLoading2, error: htlseaError2, data: htlseaData2 } = useQuery(GET_HTL_SEA2, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode},
      });

     

      const { loading: htlperroomLoading2, error: htlperroomError2, data: htlperroomData2, refetch: refetchgetgrice } = useQuery(GET_PRICES, {
        fetchPolicy: 'no-cache',
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
        
      });


     
      

     

      

     

    

  const cont_detail_tab = messages[currentLocale].cont_detail_tab;

  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);

  


 // const { loading: loadingPerDefs, data: perDefsData } = useQuery(GET_PER_DEFS);

 //const { loading: loadingPerDefs, data: perDefsData ,refetch: refetchPerDefs2 } = useQuery(GET_PER_DEFS);
  
 const { loading: loadingPerDefs, error: perDefError, data: perDefsData, refetch: refetchPerDefs2  } = useQuery(GET_PER_DEFS, {
    variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
  });
 
 //const { loading: loadingPerBase, data: perBaseData, refetch: refetchPerDefs  } = useQuery(GET_PER_BASE);
 const { loading: loadingPerBase, error: perBaseError, data: perBaseData, refetch: refetchPerDefs  } = useQuery(GET_PER_BASE, {
    variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
  });

  const [InsertContractPerPriceCalc] = useMutation(INSERT_CONT_PER_PRICE_CALC);
  const [InsertContractPerPriceGrp] = useMutation(INSERT_CONT_PER_PRICE_GRP);

  
  
  const { loading: perLoading, error: perError, data: perData, refetch: refetchPerPer2 } = useQuery(GET_PER_RED_CALC, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: varCode4 },
  });


  const [insertContPerPriceCalc] = useMutation(INSERT_CONT_PER_PRICE_CALC);

  const { loading: loadingRoomFactor, error: roomFactorError, data: roomFactorData } = useQuery(GET_ROOM_FACTOR, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode },
  });
  
  const { loading: loadingPerDefs2, error: perDefError2, data: perDefsData2 } = useQuery(GET_HTL_PERIODS_NEW, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, htlSeaIdSeq: htlSeaIdSeq  },
  });

  
  useEffect(() => {
    if (!loadingRoomFactor && !loadingPerDefs2 && roomFactorData && perDefsData2) {
     // handleInsertBaseRecordsPrice3();
    }
  }, [loadingRoomFactor, loadingPerDefs2, roomFactorData, perDefsData2]);

  const handleInsertBaseRecordsPrice3 = async () => {
    try {
      const periods = perDefsData2.tbl_htl_period;
      const roomFactors = roomFactorData.tbl_htl_room_type_factor;

      for (const period of periods) {
        for (const roomFactor of roomFactors) {
         

          const dates = getDatesBetween(period.start_date, period.end_date);
       
          for (const date of dates) {
            const updatedIdSeq = String(await handleUpdateIdSeq3()); // Her bir döngüde yeni bir idSeq al

            const result = await insertContPerPriceCalc({
              variables: {
                contId: contIdSeq,
                perRoomClass: 'STRNA',
                firmMainCode: roomFactor.firm_main_code,
                firmSubCode: roomFactor.firm_sub_code,
                perId: period.id_seq,
                adult: roomFactor.person,
                child:0,
                perPrice: (100 + (100 * period.per_price_percent/100 ))* roomFactor.per_factor,
                currency: 'USD',
                period: period.period,
                perRooms: roomFactor.r_type_code,
                days: date.toISOString(),
                updatedIdSeq: updatedIdSeq
              },
            });

            if (result.data.insert_tbl_cont_per_price.affected_rows > 0) {
              console.log("Insert successful.");
            } else {
              console.error("Insert failed.");
            }
          }
        }
      }

      console.log("Mutations successfully executed.");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getDatesBetween = (startDate, endDate) => {
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
    
    const dates = [];
    let currentDate = new Date(startDate);
    
    console.log("Original End Date:", endDate);
    
    endDate = new Date(endDate); // endDate'i kopyalayarak değişikliklerden etkilenmesini engelle
    endDate.setDate(endDate.getDate() + 1); // endDate'i bir gün sonraya ayarla
    
    console.log("Updated End Date:", endDate);
    
    while (currentDate < endDate) {
        console.log("Current Date:", currentDate);
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    
    console.log("Dates result:", dates);
    
    return dates;
};

  const getDatesBetween2 = (startDate, endDate) => {
    const dates = [];
    let currentDate = new Date(startDate);
    
    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    
    return dates;
  };

  const [displayDialog, setDisplayDialog] = useState(false);
  const [displayDialog2, setDisplayDialog2] = useState(false);
  const [loadingpop, setLoadingpop] = useState(false);
   
  const handleInsertBaseRecordsPrice3son = async () => {
    try {
      setDisplayDialog2(true);
      setLoadingpop(true);
      
      const periods = perDefsData2.tbl_htl_period;
      const roomFactors = roomFactorData.tbl_htl_room_type_factor;
      
      const records = [];
      let totalRecordsCount = 0;
  
      for (const period of periods) {
        for (const roomFactor of roomFactors) {
          const dates = getDatesBetween(period.start_date, period.end_date);
          totalRecordsCount += dates.length;
        }
      }
  
      const startIdSeq = await handleUpdateIdSeq3(totalRecordsCount);
      
      let currentIdSeq = startIdSeq;
  
      for (const period of periods) {
        for (const roomFactor of roomFactors) {
          const dates = getDatesBetween(period.start_date, period.end_date);
          
          for (const date of dates) {
            let adult = 0;
            let child = 0;
  
            if (roomFactor.per_type === "A") {
              adult = roomFactor.person;
            } else if (roomFactor.per_type === "C") {
              child = roomFactor.person;
            }
  
            const record = {
              cont_id: contIdSeq,
              r_class_code: 'STRNA',
              firm_main_code: roomFactor.firm_main_code,
              firm_sub_code: roomFactor.firm_sub_code,
              per_id: period.id_seq,
              per_price: ((baseStartPrice + (baseStartPrice * roomFactor.get_base_factor.base_price_persent / 100)) + ((baseStartPrice + (baseStartPrice * roomFactor.get_base_factor.base_price_persent / 100)) * period.per_price_percent / 100)) * roomFactor.per_factor,
              currency: varCode8,
              period: period.period,
              r_type_code: roomFactor.r_type_code,
              price_date: date.toISOString(),
              red_id: currentIdSeq,
              adult: adult,
              child: child,
              person_factor: roomFactor.per_factor,
              base_price: ((baseStartPrice + (baseStartPrice * roomFactor.get_base_factor.base_price_persent / 100)) + ((baseStartPrice + (baseStartPrice * roomFactor.get_base_factor.base_price_persent / 100)) * period.per_price_percent / 100)) * roomFactor.per_factor,
              create_user: username,
              update_user: username,
            };
  
            records.push(record);
            currentIdSeq++; // Increment currentIdSeq for the next record
          }
        }
      }
  
      const result = await insertContPerPriceCalc({
        variables: {
          records: records
        },
      });
  
      if (result.data.insert_tbl_cont_per_price.affected_rows > 0) {
        console.log("Insert successful.");
      } else {
        console.error("Insert failed.");
      }
  
      setLoadingpop(false);
      setDisplayDialog2(false);
      window.alert("Sales Olan insert successfully!");
      console.log("Mutations successfully executed.");
    } catch (error) {
      console.error("Error:", error);
    }
  };

 /* 
// toplu insert islemi

  const handleInsertBaseRecordsPrice3son = async () => {
    try {
      setDisplayDialog2(true);
      setLoadingpop(true);
        const periods = perDefsData2.tbl_htl_period;
        const roomFactors = roomFactorData.tbl_htl_room_type_factor;
        
        const records = [];

        for (const period of periods) {
          for (const roomFactor of roomFactors) {
              const dates = getDatesBetween(period.start_date, period.end_date);
      
              for (const date of dates) {
                  const updatedIdSeq = String(await handleUpdateIdSeq3()); // Her bir döngüde yeni bir idSeq al
      
                  let adult = 0;
                  let child = 0;
      
                  if (roomFactor.per_type === "A") {
                      adult = roomFactor.person;
                  } else if (roomFactor.per_type === "C") {
                      child = roomFactor.person;
                  }
      
                  const record = {
                      cont_id: contIdSeq,
                      r_class_code: 'STRNA',
                      firm_main_code: roomFactor.firm_main_code,
                      firm_sub_code: roomFactor.firm_sub_code,
                 
                     per_price:  ((baseStartPrice + (baseStartPrice * roomFactor.get_base_factor.base_price_persent / 100)) +((baseStartPrice + (baseStartPrice * roomFactor.get_base_factor.base_price_persent / 100)) *  period.per_price_percent / 100))* roomFactor.per_factor, 
                      currency: varCode8,
                      period: period.period,
                      r_type_code: roomFactor.r_type_code,
                      price_date: date.toISOString(),
                      red_id: updatedIdSeq,
                      adult: adult,
                      child: child,
                      person_factor: roomFactor.per_factor,
                      base_price: ((baseStartPrice + (baseStartPrice * roomFactor.get_base_factor.base_price_persent / 100)) +((baseStartPrice + (baseStartPrice * roomFactor.get_base_factor.base_price_persent / 100)) *  period.per_price_percent / 100))* roomFactor.per_factor, 
                      create_user: username,
                      update_user: username,
                  };
      
                  records.push(record); // record döngü içinde oluşturulduktan sonra records dizisine eklenmeli
              }
          }
      }

      const result = await insertContPerPriceCalc({
        variables: {
            records: records
        },
    });

        if (result.data.insert_tbl_cont_per_price.affected_rows > 0) {
            console.log("Insert successful.");
        } else {
            console.error("Insert failed.");
        }
        setLoadingpop(false);
        setDisplayDialog2(false);
        window.alert("Sales Olan insert successfully!");
        console.log("Mutations successfully executed.");
    } catch (error) {
        console.error("Error:", error);
    }
};



*/

  
 const handleInsertTempRecords = async () => {
    try {    
      // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = htlperData.tbl_htl_period.map((record) => ({
        id_seq: record.id_seq,
        firm_main_code: firmMainCode,
        firm_sub_code: firmSubCode,
        cont_id: contIdSeq,
        sea_id: contSeaIdSeq,
        period: record.period,
        start_date: record.start_date,
        end_date: record.end_date,
        release: record.release,
        min_stay: record.min_stay,
      }));
  
      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertPerRecords({
        variables: { records: recordsToInsert },
      });
  
      const affectedRows = insertData.insert_tbl_cont_per_def.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_main.`);
      //handleInsertTempRecords2();
      
      refetch();
      refetchPerDefs2();
      refetchPerDefs();
      
      window.alert("Contract Period insert successfully!");
      
   
      
      
    } catch (error) {
      console.error('Error inserting into tbl_dpr_main:', error);
      refetch();
      refetchPerDefs2();
      refetchPerDefs();

    }
    
  };

  const handleUpdateIdSeq3 = async (increment) => {
  try {
    const { data } = await updateIdSeq2({
      variables: {
        type: 'DPRIC',
        increment: increment,
      },
    });
    const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
    console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
    return updatedIdSeq - increment + 1; // Return the starting id_seq value
  } catch (error) {
    console.error('Güncelleme hatası:', error);
    throw error;
  }
};

  /*

  const handleUpdateIdSeq3 = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'DPRIC', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      return updatedIdSeq;
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      throw error; // Hata durumunda dışarı at
    }
  };

  */

  /* her bir kayıt icin id_seq al

  const handleUpdateIdSeq3 = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      return updatedIdSeq;
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      throw error; // Hata durumunda dışarı at
    }
  };

  const handleInsertBaseRecords = async () => {
    try {
      // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = [];
  
      for (const record of htlperroomData.tbl_cont_per_def) {
        // Her bir satır için ayrı bir ID_SEQ al
        const updatedIdSeq = String(await handleUpdateIdSeq3());
  
        // get_room_types'tan gelen tüm elemanları işle
        const roomTypeRecords = record.get_room_types.map((roomType) => ({
          cont_id: contIdSeq,
          firm_main_code: firmMainCode,
          firm_sub_code: firmSubCode,
          sea_id: contSeaIdSeq,
          per_id: record.id_seq,
          room_class: roomType.r_class_code,
          room_type: roomType.r_type_code,
          period: record.period,
          start_date: record.start_date,
          end_date: record.end_date,
          currency: updatedIdSeq,
          min_stay: record.min_stay,
          release: record.release,
        }));
  
        //  her bir eleman recordsToInsert dizisine ekle
        recordsToInsert.push(...roomTypeRecords);
      }
  
      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertPerBaseRecords({
        variables: { records: recordsToInsert },
      });
  
      const affectedRows = insertData.insert_tbl_cont_per_base.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_main.`);
      //handleInsertTempRecords2();
      refetch();
      refetchPerDefs2();
      refetchPerDefs();
      window.alert("Contract Season Base insert successfully!");
    } catch (error) {
      console.error('Error inserting into tbl_dpr_main:', error);
    
    }
  }; */

  const handleInsertBaseRecords = async () => {
    try {    
     // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = htlperroomData.tbl_cont_per_def.flatMap((record) => {
        // get_room_types'tan gelen tüm elemanları işle
        return record.get_room_types.map((roomType) => ({
          cont_id: contIdSeq,
          firm_main_code: firmMainCode,
          firm_sub_code: firmSubCode,
          sea_id: contSeaIdSeq,
          per_id: record.id_seq,
          room_class: roomType.r_class_code,
          room_type: roomType.r_type_code,
          period: record.period,
          start_date: record.start_date,
          end_date: record.end_date,
          currency: varCode8,
          min_stay: record.min_stay,
          release: record.release,

        }));
      });
  
      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertPerBaseRecords({
        variables: { records: recordsToInsert },
      });
  
      const affectedRows = insertData.insert_tbl_cont_per_base.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_main.`);
      //handleInsertTempRecords2();
      refetch();
      refetchPerDefs2();
      refetchPerDefs();
      window.alert("Contract Season Base insert successfully!");
      
   
      
      
    } catch (error) {
      console.error('Error inserting into tbl_dpr_main:', error);
      refetch();
      refetchPerDefs2();
      refetchPerDefs();
    }
    
  }; 

//DIKKKKKKAAAAAATTTTTTTTTTTTTTT





/*const onBaseRecordsPriceButtonClick = async () => {
  try {
    console.log("cont id refect:",contIdSeq)
    
    if (htlperroomLoading2) {
      console.log('Loading...');
      await refetch();     
      await refetchgetgrice();
      return;
        }
       await refetch();     
       await refetchgetgrice();

    
   
    console.log("cont id refect2:",contIdSeq)
    await handleInsertBaseRecordsPrice();
    console.log("cont id refect3:",contIdSeq)
    
  } catch (error) {
   
  console.log('Refetched data:', htlperroomData2.tbl_cont_per_grp);
  handleInsertBaseRecordsPrice();
 
    console.error('Error in button click:', error);
    // Hata durumunu kullanıcıya bildirebilirsiniz.
    alert('Bir hata oluştu. Daha fazla bilgi için konsolu kontrol edin.');
  }
}; */


const [insertingData, setInsertingData] = useState(false);

useEffect(() => {
  // Tıkladıktan sonra sorgu yüklendiyse insert işlemini hemen yap
  if (!htlperroomLoading2 && insertingData) {
    handleInsertBaseRecordsPrice();
    setInsertingData(false);
  }
}, [htlperroomLoading2, insertingData]);

const onBaseRecordsPriceButtonClick = async () => {
  try {
    // Butona tıklandığında sorguyu yükle
    await refetch();
    console.log('Refetching...');
    await refetchgetgrice();

    // Eğer sorgu yüklenmediyse, insertingData state'ini true yap
    if (htlperroomLoading2) {
      console.log('Loading...');
      setInsertingData(true);
    } else {
      // Eğer sorgu yüklendiyse, tekrar yüklenmesi için setInsertingData(true) yap
      setInsertingData(true);
    }
  } catch (error) {
    console.error('Error in button click:', error);
    alert('Bir hata oluştu. Daha fazla bilgi için konsolu kontrol edin.');
  }
};






const handleInsertBaseRecordsPrice= async () => {
  
  try {
    if (htlperroomLoading2) {
      console.log('Loading...');
      return;
    }

    console.log('First call data:', htlperroomData2.tbl_cont_per_grp);
    await refetchgetgrice();
    console.log('Refetch data:', htlperroomData2.tbl_cont_per_grp);

    if (htlperroomError2) {
      console.error('Error loading prices:', htlperroomError2);
      return;
    }

    const recordsToInsert = [];

    htlperroomData2.tbl_cont_per_grp.forEach((record) => {
      if (!record.grp_per || !record.grp_base) {
        console.error('Invalid data structure:', record);
        console.log('GraphQL Data:', htlperroomData2);
        return;
      }

      const baseRecords = Array.isArray(record.grp_base) ? record.grp_base : [record.grp_base];
      const perRecords = Array.isArray(record.grp_per) ? record.grp_per : [record.grp_per];

      baseRecords.forEach((baseRecord) => {
        perRecords.forEach((perRecord) => {
          let per_price, adult, child;
          console.log('GraphQL Data:', htlperroomData2);         
          
          

  if (perRecord.red_sup_type === "R") {
    // "R"
    if (perRecord.person_type === "A") {
      // "A"
      child = 0;
      adult = perRecord.person;
      if (perRecord.person === 1) {
        // "1 A"
        per_price =  baseRecord.base_price - (perRecord.percent * baseRecord.base_price / 100) ;
      } else if (perRecord.person === 2) {
        // "2 A"
        per_price =  baseRecord.base_price - ( perRecord.percent * baseRecord.base_price / 100) ;
      } else {
        // Diğer durumlar
         per_price = baseRecord.base_price - (perRecord.percent * baseRecord.base_price / 100);
      }
    } else if (perRecord.person_type === "C") {
      // "R" "C"
      adult = 0;
      child = perRecord.person;
      if (perRecord.person === 1) {
        // "1 C"
        per_price = (2 * baseRecord.base_price)- ((2 * baseRecord.base_price) * perRecord.percent / 100);
      } else if (perRecord.person === 2) {
        // "2 C"
        per_price = (2 * baseRecord.base_price)- ((2 * baseRecord.base_price) * perRecord.percent / 100);
      } else {
        // Diğer durumlar
        per_price = (2 * baseRecord.base_price)- ((2 * baseRecord.base_price) * perRecord.percent / 100);
      }
    }
  } else if (perRecord.red_sup_type === "S") {
    // "S"
    if (perRecord.person_type === "A") {
      child = 0;
      adult = perRecord.person;
      if (perRecord.person === 1) {
        // "1 A"
        per_price = (perRecord.percent * baseRecord.base_price / 100) + baseRecord.base_price;
      } else if (perRecord.person === 2) {
        // "2 A"
        per_price = (perRecord.percent * baseRecord.base_price / 100) + baseRecord.base_price;
      } else {
        // Diğer durumlar
        per_price = (perRecord.percent * baseRecord.base_price / 100); 
      }
    } else if (perRecord.person_type === "C") {
      adult = 0;
      child = perRecord.person;
      if (perRecord.person === 1) {
        // "1 C"
        per_price = (2 * baseRecord.base_price)- ((2 * baseRecord.base_price) * perRecord.percent / 100);
      } else if (perRecord.person === 2) {
        // "2 C"
        per_price = (2 * baseRecord.base_price)- ((2 * baseRecord.base_price) * perRecord.percent / 100);
      } else {
        // 2> C
        per_price = (2 * baseRecord.base_price)- ((2 * baseRecord.base_price) * perRecord.percent / 100);
      }
    }
  } 

          /* sadece R ve S tarafı
          
          if (perRecord.red_sup_type === "R") {
          
            if (perRecord.person === 2) {
              per_price = (perRecord.percent * baseRecord.base_price / 100) * 2;
            } else {
              per_price = perRecord.percent * baseRecord.base_price / 100;
            }
          } else {
            // "S" hesaplaması
            if (perRecord.person === 2) {
              per_price = (perRecord.percent * baseRecord.base_price / 100) * 4;
            } else {
              per_price = perRecord.percent * baseRecord.base_price / 100;
            }
          } */


          const newRecord = {
                   

            cont_id: perRecord.cont_id,
            firm_main_code: record.firm_main_code,
            firm_sub_code: record.firm_sub_code,
            per_id: perRecord.per_id,
            red_id: record.id_seq, // Buradaki değişiklik
            period: perRecord.period,
            adult: adult,
            child: child,
            r_type_code: baseRecord.room_type,
            per_price: per_price,
            currency: baseRecord.currency,
          };

          recordsToInsert.push(newRecord);
        });
      });
    });

    if (recordsToInsert.length > 0) {
      const { data: insertData } = await insertPerBaseRecords2({
        variables: { records: recordsToInsert },
      });

      const affectedRows = insertData.insert_tbl_cont_per_price.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_cont_per_price.`);
      refetch();
      refetchgetgrice();
      

      window.alert('Contract price calc insert successfully!');
    } else {
      console.log('No records to insert.');     
      refetch();
      refetchgetgrice();
    }
  } catch (error) {
    console.error('Error inserting into price calc:', error);
    refetch();
    refetchgetgrice();

    if (error.message.includes('Uniqueness violation.')) {
      // PostgreSQL'den gelen benzersizlik hatası
      alert('Bu kayıt zaten mevcut. Lütfen farklı bir kayıt ekleyin.');
    } else {
      // Diğer hata türleri
      alert('Bir hata oluştu. Daha fazla bilgi için konsolu kontrol edin.');
    }
  }
};

  //DIKKAAAAATTTTTTTTTT

  const handleInsertContPerBase = async () => {
    try {
      if (tblContPerDefLoading) {
        console.log("Loading...");
        return;
      }

      if (tblContPerDefError) {
        console.error("Error fetching tbl_cont_per_def data:", tblContPerDefError);
        return;
      }

      const recordsToInsert = tblContPerDefData.tbl_cont_per_def.map((record) => ({
        id_seq: record.id_seq,
        start_date: record.start_date,
        end_date: record.end_date,
        r_class_code: record.get_room_types[0].r_class_code,
        r_type_code: record.get_room_types[0].r_type_code,
        period: record.period,
        currency: varCode8,
        min_stay: record.min_stay,
        release: record.release,
      }));

      const { data: insertData } = await insertContPerBase({
        variables: { records: recordsToInsert },
      });

      const affectedRows = insertData.insert_tbl_cont_per_base.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_cont_per_price.`);
    } catch (error) {
      console.error('Error inserting into tbl_cont_per_base:', error);
      console.error('Ekstra hata bilgisi:', error.graphQLErrors, error.networkError);
    }
  };





  const handlePerPerinsertGrp = () => {
    if (Array.isArray(perData.tbl_cont_per_per)) {
      const processedRooms = [];
  
      perData.tbl_cont_per_per.forEach((perPerItem) => {
        const { rooms,  period, per_id, id_seq, cont_id, ...otherData } = perPerItem;
        const roomsArray = (rooms || '').split(',');
  
        roomsArray.forEach((room) => {
          InsertContractPerPriceCalc({
            variables: {
              redIdSeq: id_seq,
              perRoomClass: period,
              perId: per_id,
              period: period,
              contId: cont_id,
              currency: varCode8,
              adult: 0,
              child: 0,
              perPrice: 0,
              perRooms: room,
              firmMainCode: firmMainCode,
              firmSubCode: firmSubCode,
              // Diğer değişkenleri ekleyin
            },
          })
              .then(() => {
                console.log(`Oda ${room} için kontrat sezonu başarıyla eklendi!`);
              })
              .catch((error) => {
                console.error(`${room} için kontrat sezonu eklerken hata oluştu:`, error);
                console.error('Mutasyon hatası:', error);
                console.error('Ekstra hata bilgisi:', error.graphQLErrors, error.networkError);
              });
        
        });
      });
    } else {
      console.error("perData.tbl_cont_per_per bir dizi değil!", perData.tbl_cont_per_per);
    }
  };


  const handlePerPerinsertPertoGrp = () => {
    if (Array.isArray(perData.tbl_cont_per_per)) {
      const processedRooms = [];
  
      perData.tbl_cont_per_per.forEach((perPerItem) => {
        const { rooms,  per_id, id_seq, cont_id, ...otherData } = perPerItem;
        const roomsArray = (rooms || '').split(',');
  
        roomsArray.forEach((room) => {
          InsertContractPerPriceGrp({
            variables: {
              redIdSeq: id_seq,              
              perId: per_id,            
              contId: cont_id,             
              perRooms: room,
              firmMainCode: firmMainCode,
              firmSubCode: firmSubCode,
            
            },
          })
              .then(() => {
                console.log(`Oda ${room} için kontrat Grupları başarıyla eklendi!`);
                onBaseRecordsPriceButtonClick();
                
              })
              .catch((error) => {
                console.error(`${room} için kontrat sezonu eklerken hata oluştu:`, error);
                console.error('Mutasyon hatası:', error);
                console.error('Ekstra hata bilgisi:', error.graphQLErrors, error.networkError);
              });
        
        });
      });
    } else {
      console.error("perData.tbl_cont_per_per bir dizi değil!", perData.tbl_cont_per_per);
    }
  };

  useEffect(() => {
    handleBasePriceUpdate();
  }, [basePricetrg]);




  const handleBasePriceUpdate = () => {
    UpdateContBasePrice({
      variables: {
        contIdSeq: contIdSeq,
        contSeaIdSeq: contSeaIdSeq,
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        basePeriod: basePeriod,
        roomType: roomType,
        basePrice: basePrice,
       

        
      },
    })
      .then(() => {
        window.alert("Contract Base updated successfully!");
        refetch();
        
       refetchPerDefs();
       
      })
      .catch((error) => {
        console.error("Error updating Cont Base Price:", error);
      });
  };

  const handlePerPriceDelete = () => {
    DeleteContBasePrice({
      variables: {
        contIdSeq: contIdSeq,       
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
      
       

        
      },
    })
      .then(() => {
        window.alert("Contract Per Deleted successfully!");
        handlePerGrpDelete();
      
      })
      .catch((error) => {
        console.error("Error Deleted Cont Per Price:", error);
      });
  };


  const handlePerGrpDelete = () => {
    DeleteContPerGrp({
      variables: {
        contIdSeq: contIdSeq,       
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
      
       

        
      },
    })
      .then(() => {
        window.alert("Contract Per Deleted successfully!");
        handlePerPerinsertPertoGrp();
      
      })
      .catch((error) => {
        console.error("Error Deleted Cont Per Price:", error);
      });
  };

  

  useEffect(() => {
    if (!loadingPerDefs && perDefsData) {
      const dynamicColumns = perDefsData.tbl_cont_per_def.map((def) => {
        const startDate = new Date(def.start_date);
        const endDate = new Date(def.end_date);
  
        const formattedStartDate = startDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric' });
        const formattedEndDate = endDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric' });
  
        return {
          field: def.period,
          header: (
            <>
              {def.period}
              <br />
              ({formattedStartDate} - {formattedEndDate})
            </>
          ),
          body: (rowData) => (
            <div>
              {rowData['room_type']} - {rowData['get_room_name']?.r_type_name}
            </div>
          ),
        };
      });
  
      setTableColumns([
        { field: 'room_type', header: 'Room Type' },
        ...dynamicColumns,
      ]);
    }
  }, [loadingPerDefs, perDefsData]);
  
  useEffect(() => {
    if (!loadingPerBase && perBaseData) {
      const uniqueRoomTypes = [...new Set(perBaseData.tbl_cont_per_base.map((item) => item.room_type))];
  
      const dynamicData = uniqueRoomTypes.map((roomType) => {
        const rowData = {
          room_type: roomType,
        };
  
        perBaseData.tbl_cont_per_base
          .filter((item) => item.room_type === roomType)
          .forEach((item) => {
            rowData[item.period] = item.base_price;
            rowData['r_type_name'] = item.get_room_name?.r_type_name; // Değişiklik yapıldı
          });
  
        return rowData;
      });
    //  fetch();
  
      setTableData(dynamicData);
    }
  }, [loadingPerBase, perBaseData]);


    

    useEffect(() => {
        if (firmData) {  
               

          setContIdSeq(varCode4);
       // setContIdSeq(firmData.cont_id);
          setContSeaIdSeq(firmData.id_seq);
          setHtlSeaIdSeq(firmData.season_id);
          setStartDate(new Date(firmData.start_date));
          setEndDate(new Date(firmData.end_date));
          refetch();  
          
    
        }
      }, [firmData]);

      const { xloading, xdata } = useQuery(GET_HTL_SEA, {
        variables: {
          firmMainCode: firmMainCode,
          firmSubCode: firmSubCode
          
        },
      });

   


    /*  useEffect(() => {
        if (!htlseaLoading2 && htlseaData2) {
          const htlSeaData = htlseaData2.tbl_htl_season[0]; // İlk öğeyi al, eğer varsa
    
          if (htlSeaData) {
            // Tarihleri set et
            setStartDate(new Date(htlSeaData.start_date));
            setEndDate(new Date(htlSeaData.end_date));
          }
        }
      }, [htlSeaIdSeq]);*/

      

      const [selectedRowData, setSelectedRowData] = useState(null);
      

      const onEditButtonClick = (rowData) => {
       // setSelectedRowData(rowData);
        setDisplayDialog(true);
        setVarCode3(contSeaIdSeq);
        // handleEditButtonClick'i çağırırken doğru parametreleri geçir
     //   handleEditButtonClick(rowData);
      };

      const handleEditButtonClick = ({ field, value, rowData }) => {
        if (rowData) {
          const period = rowData['period'];
          const basePrice = rowData['base_price'];
          const roomType = rowData['room_type'];

        
          console.log('Editing Row Data:');
          console.log('Period:', period);
          console.log('Base Price:', basePrice);
          console.log('Room Type:', roomType);
          console.log('Field:', field); 
          console.log('Value:', value); 
        
          //satırın verilerini state'e atabilir
        }
      };


   


      const handleUpdateIdSeq2 = async () => {
        try {
          const { data } = await updateIdSeq2({
            variables: {
              type: 'MFIRM', 
            },
          });
          const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
          console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
          setContSeaIdSeq(updatedIdSeq); 
          
          
         
         // setVarCode(updatedIdSeq.toString());  
          console.log(contSeaIdSeq);         
           
          
        } catch (error) {
          console.error('Güncelleme hatası:', error);
        }
      };


      const handleUpdateIdSeq = async () => {
        const requiredFields = ['htlSeaIdSeq', 'baseStartPrice' ]; // Required fiels
        const customFieldNames = {
            htlSeaIdSeq: "Hotel Sezon Kodu",
            baseStartPrice: "Base Price"
        
    
        };
        const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
      
        if (emptyFields.length === 0) {
          try {
            const { data } = await updateIdSeq1({
              variables: {
                type: 'MFIRM', 
              },
            });
            const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
            console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
            setContSeaIdSeq(updatedIdSeq); 
            setIdSeqTrg(updatedIdSeq);
            
            console.log(contSeaIdSeq);
            // setVarCode(updatedIdSeq.toString());  
          } catch (error) {
            console.error('Güncelleme hatası:', error);
          }
        } else {
          
          const emptyFieldsMessage = `Lütfen Hotel Sezonu & Base Price doldurun: ${emptyFields.join(', ')}`;
         // console.log(emptyFieldsMessage);
          window.alert(emptyFieldsMessage);
        }
      };
      
      const validateForm = (requiredFields, customFieldNames) => {
        // Tüm gerekli alanları kontrol et
        for (const field of requiredFields) {
          if (!eval(field)) {
            return false;
          }
        }
      
        return true;
      };
      
      const getEmptyFields = (requiredFields, customFieldNames) => {
        const emptyFields = [];
      
        // Boş olan alanları bul
        for (const field of requiredFields) {
          if (!eval(field)) {
            emptyFields.push(customFieldNames[field]);
          }
        }
      
        return emptyFields;
      };
    
    
        useEffect(() => {
        // newId değeri bağlamdaki yeni değeri yansıtır
        if (idSeqtrg !== '') {
          // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
          handleinsert();  
        
        }
      }, [idSeqtrg]);

      useEffect(() => {
        // varCode4 değiştiğinde yapılacak işlemler
        setContIdSeq(varCode4);
        setVarCode4(varCode4);
        setSomeCondition(true);
        console.log("var:", varCode4)
        
        // refetch fonksiyonunu çağırma koşullarına bağlı olarak
        if (someCondition) {
          refetch();
          refetchgetgrice();
        }
      }, [varCode4, setContIdSeq, someCondition]);


          

      const handleinsert = () => {
        InsertContractSea({
         variables: {
           firmSubCode: firmSubCode,
           firmMainCode: firmMainCode,
           firmSubCode: firmSubCode,
           contIdSeq: varCode4,
           contSeaIdSeq: contSeaIdSeq,
           htlSeaIdSeq: htlSeaIdSeq,
           startDate: new Date(startDate).toLocaleDateString(),
           endDate: new Date(endDate).toLocaleDateString(),
          
         },
       })
         .then(() => {
           window.alert("Price Season insert successfully!");
           
        //   handleInsertTempRecords();
           refetch();
        
         })
         .catch((error) => {
           console.error("Error insert cont Season:", error);
           console.error("GraphQL Errors:", error.graphQLErrors);
         });
     };
      
      
      

    
      const handleDialogSave = () => {
        // Burada dialog penceresinden alınan yeni değerleri kullanarak ilgili işlemleri yapabilirsiniz.
        // Örneğin, bu değerleri bir API'ye gönderebilir ve tabloyu güncelleyebilirsiniz.
        
        // Değişiklikleri uyguladıktan sonra dialog penceresini kapatın
        setDisplayDialog(false);
      };
    
      const handleDialogCancel = () => {
        // İptal edildiğinde, seçili satır verilerini sıfırlayın ve dialog penceresini kapatın
        setSelectedRowData(null);
        setDisplayDialog(false);  
        refetch();
        refetchgetgrice();
        
        refetchPerDefs(); 

      };
      
      
        const [editingRowData, setEditingRowData] = useState(null);
        

        
        const onCellEditInit = (e) => {
            const { rowData } = e;
          
            // Eğer editingRowData zaten set edilmişse tekrar set etme
            if (!editingRowData) {
              setEditingRowData(rowData);
            }
          };
          useEffect(() => {
            // Bu useEffect, editingRowData state'i güncellendiğinde çalışacak
            if (editingRowData) {
              // Eğer editingRowData değeri mevcutsa, burada gerekli işlemleri gerçekleştirin
              console.log('editingRowData:', editingRowData);
            }
          }, [editingRowData]);
          
          const onCellEditComplete = (e) => {
            console.log('Hücre düzenleme tamamlandı:', e);
          
            const { field, value, rowData } = e;
          
            // Eğer rowData undefined ise, hatayı konsola yazdır ve işlemi sonlandır
            if (!rowData) {
              console.error('rowData is undefined!');
              return;
            }
          
            const roomType = rowData['room_type'];
          
            // Düzenlenen hücre bilgilerini konsola yazdırma
            console.log('Field:', field);
            console.log('Value:', value);
            console.log('Room fr Type:', roomType);
            setBasePrice(value);
            setRoomType(roomType);
            setBasePeriod(field);
            setBasePriceTrg(basePricetrg + 1);
            
           
          
            // Ilgili satırdaki veriyi kontrol et ve undefined değilse işlemleri gerçekleştir
            if (editingRowData) {
              console.log('Row Data:', editingRowData);
          
              // Örneğin, period, base_price, room_type gibi özel bilgilere erişebilirsiniz
              const period = editingRowData['period'];
              const basePrice = editingRowData['base_price'];
              const roomType = editingRowData['room_type'];
              console.log('Period:', period);
              console.log('Base Price:', basePrice);
              console.log('Room Type:', roomType);
             
          
              // Düzenleme tamamlandığında yapılacak işlemleri burada gerçekleştirin
           //   setEditingRowData(null); // Düzenleme tamamlandığında state'i temizle
            } else {
              console.error('editingRowData is undefined!');
            }
          };

          const onCellEditComplete2 = (e) => {
            console.log('Hücre düzenleme tamamlandı:', e);
          
            const { field, value, rowData } = e;
          
            // Eğer rowData undefined ise, hatayı konsola yazdır ve işlemi sonlandır
            if (!rowData) {
              console.error('rowData is undefined!');
              return;
            }
          
            const roomType = rowData['room_type'];
            const perId = rowData['per_id'];
            const roomName = rowData['r_type_name'];
          
            // Düzenlenen hücre bilgilerini konsola yazdırma
            console.log('Field:', field);
            console.log('Value:', value);
            console.log('Room xType:', roomType);
            console.log('Per:', perId);
            console.log('name:', roomName);

            setVarCode6(field);
            setVarCode7(roomType);
           


            
           
            onEditButtonClick();
          //  setDisplayDialog(true);
          
            // Ilgili satırdaki veriyi kontrol et ve undefined değilse işlemleri gerçekleştir
            if (editingRowData) {
              console.log('Row Data:', editingRowData);
          
              // Örneğin, period, base_price, room_type gibi özel bilgilere erişebilirsiniz
              const period = editingRowData['period'];
              const basePrice = editingRowData['base_price'];
              const roomType = editingRowData['room_type'];
              
              console.log('Period:', period);
              console.log('Base Price:', basePrice);
              console.log('Room Type:', roomType);
          
              // Düzenleme tamamlandığında yapılacak işlemleri burada gerçekleştirin
           //   setEditingRowData(null); // Düzenleme tamamlandığında state'i temizle
            } else {
              console.error('editingRowData is undefined!');
            }
          };

          const RoomTypeEditor = (props) => {
            const { value, onValueChange, rowData } = props;
          
            return (
              <div>
                {value}
              </div>
            );
          };

          const TextEditor = (props) => {
            const { value, onValueChange, rowData } = props;
          
            const handleKeyPress = (e) => {
              if (e.keyCode === 13) {
                // Enter tuşuna basıldığında yapılacak işlemleri burada tanımlayabilirsiniz
                onCellEditComplete({ field: props.field, value: e.target.value, rowData });
            //    handleEditButtonClick({ field: props.field, value: e.target.value, rowData }); // Bu satırı ekleyin
              }
            };

            const handleKeyPress2 = (e) => {
                
                  // Enter tuşuna basıldığında yapılacak işlemleri burada tanımlayabilirsiniz
                  onCellEditComplete2({ field: props.field, value: null, rowData });
              //   handleEditButtonClick({ field: props.field, value: null, rowData }); // Bu satırı ekleyin
              
              };
              //<Button label="Edit" onClick={() => handleKeyPress2(rowData)} />
          
            return (
                <div className="flex h-2 items-center">
                <InputText
                  value={value}
                  onChange={(e) => {
                    if (onValueChange) {
                      onValueChange(e.target.value);
                    }
                  }}
                  onKeyDown={handleKeyPress}
                  className="w-3/4 mr-2 p-0"
                />
                <button
                  onClick={() => handleKeyPress2(rowData)}
                  className="cursor-pointer ml-2 flex items-center justify-start"
                >
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
              <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
               </svg>
                </button>
              </div>
            );
          };
                 
        /*  const textEditor = (props) => {
            const { value, onValueChange, rowData } = props;
          
            const handleKeyPress = (e) => {
              if (e.keyCode === 13) {
                // Enter tuşuna basıldığında yapılacak işlemleri burada tanımlayabilirsiniz
                onCellEditComplete({ field: props.field, value: e.target.value, rowData });
              }
            };
          
            return (
              <div>
                <InputText
                  value={value}
                  onChange={(e) => {
                    if (onValueChange) {
                      onValueChange(e.target.value);
                    }
                  }}
                  onKeyDown={handleKeyPress}
                />
                <Button label="Edit" onClick={() => onEditButtonClick(rowData)} />
              </div>
            );
          };*/


         

              useEffect(() => {
                if (htlseaData && htlSeaIdSeq) {
                  const selectedSea = htlseaData.tbl_htl_season.find(sea => sea.id_seq === htlSeaIdSeq);
                  
                  if (selectedSea) {
                    setStartDate( new Date(selectedSea.start_date));              
                    setEndDate( new Date(selectedSea.end_date));
                  }
              
                  console.log("start date:", selectedSea ? selectedSea.start_date : null);
                }
              }, [htlSeaIdSeq, htlseaData]);
          

         /* const htlSeaItems = htlseaData && htlseaData.tbl_htl_season
          ? htlseaData.tbl_htl_season.map(item => ({
              label: item.desc,
              value: item.id_seq,
              name: item.desc, 
            }))
          : [];*/

          const htlSeaItems = htlseaData && htlseaData.tbl_htl_season
          ? htlseaData.tbl_htl_season.map(item => ({
              label: (
                <div>
                  <div>{item.desc}</div>
                  <div>Start Date: {new Date(item.start_date).toLocaleDateString('en-GB')}</div>
          <div>End Date: {new Date(item.end_date).toLocaleDateString('en-GB')}</div>
                </div>
              ),
              value: item.id_seq,
            }))
          : [];
  
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;
  
    return (
        <>
          <Fieldset>
            <div className="flex">
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={contIdSeq}
                  onValueChange={(e) => setContIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Season Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={contSeaIdSeq}
                  onValueChange={(e) => setContSeaIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Hotel Season Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={htlSeaIdSeq}
                  onValueChange={(e) => setHtlSeaIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>

              <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Hotel Seasons"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" 
        style={{ width: '384px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={htlSeaIdSeq}
         options={htlSeaItems}
         onChange={(e) => setHtlSeaIdSeq(e.value)}
         placeholder={"select_a_department_holder"}
         />
       </div>

   

              <div className="w-2/12 h-10 gap-3">
        <label                
         htmlFor="firmname"> {"Season Start"}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate} dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>
      

      <div className="w-2/12 gap-3">
        <label                
         htmlFor="firmname"> {"Season End"}</label>
        <Calendar className="w-1/8 h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>
            </div>
            <br></br>

            <div className="flex items-center">
            <div className="mr-2 w-1/1">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {"Base Start Price"}
    </label>
    <InputNumber
      inputId="integeronly"
      useGrouping={false}
      value={baseStartPrice}
      onValueChange={(e) => setBaseStartPrice(e.value)}
      className="w-full h-11 border-gray-300 rounded-md"
    
    />                
  </div>
  
  <button
    className={`bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md ${
      contSeaIdSeq ? 'cursor-not-allowed opacity-50' : ''
    }`}
    onClick={contSeaIdSeq ? null : handleUpdateIdSeq}
    disabled={!!contSeaIdSeq}
  >
    {contSeaIdSeq ? 'Sezon Tanımlanmıs' : 'Yeni sezon'}
  </button>

  

  <button
    className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
    onClick={handleInsertBaseRecordsPrice3son}
  >
    {"Sezon & Fiyat Olustur"}
  </button>
</div>



    

<div>
            <button onClick={handleInsertBaseRecordsPrice3son}>Insert Records</button>
            <Dialog
                header="Inserting Records"
                visible={displayDialog2}
                style={{ width: '30vw' }}
                onHide={() => setDisplayDialog2(false)}
            >
                {loadingpop ? (
                    <div style={{ textAlign: 'center' }}>
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" animationDuration=".5s" />
                    </div>
                ) : (
                    <div>Records inserted successfully.</div>
                )}
            </Dialog>
        </div>



      
      

          </Fieldset>
      
          <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Room Types & Season Price"}
            </span>
          }
          className="ml-5 flex"
        >
      <div>
  

  <DataTable
value={tableData}
frozenHeader
scrollable
showGridlines
stripedRows="true"
editMode="cell"
size={"small"}
onCellEditComplete={onCellEditComplete}
footerColumnGroup={"footerGroup"}
>
{tableColumns.map((column) => (
 <Column
   key={column.field}
   editor={column.field === 'room_type' ? (props) => <RoomTypeEditor {...props} /> : (props) => <TextEditor {...props} />}
   field={column.field}
   className="text-sm font-semibold text-right"  
   header={<span className="text-sm text-center font-semibold text-gray-900">{column.header}</span>}
   body={(rowData) => {
     if (column.field === 'room_type') {
       return (
         <div>
           {rowData['room_type']} - {rowData['r_type_name']}
         </div>
       );
     } else {
       // Diğer kolonlar için normal içerik
       return <div>{rowData[column.field]}</div>;
     }
   }}
   style={{
     textAlign: 'left',
     width: column.field === 'room_type' ? '30rem' : '10rem', // Genişlik ayarı
     fontWeight: column.field === 'room_type' ? 'bold' : 'Light', // Bold stil
   }}
 />
))}
</DataTable>

   {/* Dialog penceresi */}
   <Dialog header={"Contract Room Base Price"} visible={displayDialog} style={{ width: '50vw' }} onHide={handleDialogCancel}>
   
       <div>

       
    
      
       </div>
     
   </Dialog>
 </div>

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Reduction & Supplement %"}
            </span>
          }
          className="ml-5 flex"
        >
    
           

              </TabPanel>
            
          </TabView>
      
          
        </>
      );
      
  };
  
  export default HtlSalesPlanSeasonPrice;

 


      
  